export enum Unit {
  MM = 'MM',
  M = 'M',
  IN = 'IN',
  FT = 'FT',
}
